export const home = {
  'Made for': 'Made for',
};
